<header class="no-margins-hug hug-header auto-header margin-vertical-header acmic-delinquency-header" [ngClass]="{'mh24': isAcmic}">
  <div class="billing-header-acmic" *ngIf="isAcmic">
    <img 
      src="{{policy?.displayType?.icon}}"
      width="40" height="40"  class="header-icon-ml" alt="car icon"
    >
  </div>
  <div class="type-title deliquency-notice" [ngClass]="{'acmic-pol-header-w':isAcmic}">
    <h1 class="title " [ngClass]="{ 'black_text acmic-policy-style term-duration lowercase': isAcmic }">
      <ng-container *ngIf="!isAcmic; else acmicPolicyType">
        <span class="icon-flex-container margin-bottom mb8">
          <img 
            src="{{policy?.displayType?.icon}}"
            width="40" height="40" 
            class="margin-right mr8"
            alt="{{policy?.policyType?.toLowerCase()}} icon"
          />
            {{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }}
        </span>
      </ng-container>
      <ng-template #acmicPolicyType>
        {{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }}
      </ng-template>  
      <span [ngClass]="{'policy-status-color': (policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE'),
      'red-color': !(policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE') }">
     <small class="display-inline reponsive-mt-8">
      <strong [ngClass]="{'acmic-term-date': isAcmic, 'red-color': !(policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE')}"> {{ policy?.effDate | customDateFormat }} {{ '-' | translate }}
          {{ policy?.expDate | customDateFormat }}</strong></small>
      </span>
    </h1>
  </div>
  <ng-container *ngIf="policy?.isDelinquency">
    <div class="margin-top mt16 bn-error-notice-sec" [ngClass]="{'acmic-notice-container':isAcmic}">
      <app-bn-error-notice
        [amount]='policy?.exitDelinquencyAmount?.theAmount' 
        [date]='policy?.policyCancellationEffectiveDate'
        [policyCancellationReason]='policy?.policyCancellationReason'
        [policy]='policy'>
      </app-bn-error-notice>
    </div>
  </ng-container>
</header>
